import axiosPost from '../axiosPost';

export const cargosGet = async (arg) => {
    const { params } = arg;
    const body = {
        "service": "CargoGet",
        "params": params ? params : {}
    };

    try {
        const result = await axiosPost('Y', body, arg)
        return result.data.result
    } catch (err) {
        console.log(err)
    };
};